import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CartListItem from "../../CartList/components/CartListItem";
import MoveBtn from "../../../molecules/components/MoveBtn";
import ActionBtn from "../../../molecules/components/ActionBtn";
import SummaryPrice from "../../../molecules/components/SummaryPrice";
import UserPersonalSection from "../../../molecules/components/UserPersonalSection";
import CompanySection from "../../../molecules/components/CompanySection";
import ContentHeader from "../../../molecules/components/ContentHeader";
import { Link } from "react-router";
import {
  storeOrderData,
  getOrderDetail,
  getCompanyDetail,
  orderLoading
} from "../../../store/order";
import { loading, getCurrencySign } from "../../../store/common";
import shop from "../../../api/shop";
import { store } from "../../../main.js";
import { userIsAuthenticated } from "../../../auth";
import MediaQuery from "react-responsive";
import { RingLoader } from "react-spinners";
import { getTranslate } from "react-localize-redux";

class OrderDetailContainer extends Component {
  componentDidMount() {
    store.dispatch(orderLoading(true));
    shop.getOrder_detail(this.props.params.id, orderDetailFromApi => {
      orderDetailFromApi.then(order => {
        store.dispatch(storeOrderData(order));
        store.dispatch(orderLoading(false));
      });
    });
  }

  render() {
    return (
      <div className="col-12 shipping__section">
        <ContentHeader
          title={this.props.orderData ? this.props.orderData.order_number : ""}
          breadCrumbs={[
            { name: "Orders", route: "/orders" },
            {
              name: this.props.orderData
                ? this.props.orderData.order_number
                : "",
              route: null
            }
          ]}
        />

        {this.props.isLoading ? (
          <RingLoader
            color={"#d42e2b"}
            loading={this.props.isLoading}
            size={120}
            margin={20}
          />
        ) : (
          <React.Fragment>
            <div className="container mt-3 mb-3">
              <div className="row">
                <div className="col-12 col-md-6 bg-light pt-4 pb-4">
                  {this.props.orderData.user &&
                  this.props.orderData.user.personal ? (
                    <UserPersonalSection
                      title="Personal information"
                      data={this.props.orderData.user}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-12 col-md-6 bg-light pt-4 pb-4">
                  {this.props.orderData.user &&
                  this.props.orderData.user.company ? (
                    <CompanySection
                      title="Company detail"
                      data={this.props.orderData.user.company}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            <div className="container mt-3 mb-3 bg-light">
              <div className="row">
                <div className="col-12">
                  <h4>Note</h4>
                </div>
                <div className="col-12">{this.props.orderData.note}</div>
              </div>
            </div>

            <div className="container mt-3 mb-3">
              {this.props.orderData.products
                ? this.props.orderData.products.map(orderProduct => (
                    <CartListItem
                      key={orderProduct.id}
                      cartProduct={orderProduct}
                      isSelected={false}
                      selectCartProduct={null}
                      deleteCartProduct={null}
                      enableToManipulate={false}
                      currencySign={this.props.currencySign}
                      labelQuantity={this.props.translate(
                        "routes.cartList.cartListItem.quantity"
                      )}
                      labelDiscount={this.props.translate(
                        "routes.cartList.cartListItem.discount"
                      )}
                      labelPrice={this.props.translate(
                        "routes.cartList.cartListItem.price"
                      )}
                      labelTotal={this.props.translate(
                        "molecules.components.summaryPrice.total_msg"
                      )}
                    />
                  ))
                : "still loading"}

              <SummaryPrice
                totalExclVat={this.props.orderData.totalExcludedVatPrice}
                vat={this.props.orderData.vat}
                shipping={this.props.orderData.shippingCost}
                total={this.props.orderData.totalPrice}
                currencySign={this.props.currencySign}
                totalVatMsg={this.props.translate(
                  "molecules.components.summaryPrice.total_vat_msg"
                )}
                shippingMsg={this.props.translate(
                  "molecules.components.summaryPrice.shipping_msg"
                )}
                vatMsg={this.props.translate(
                  "molecules.components.summaryPrice.vat_msg"
                )}
                totalMsg={this.props.translate(
                  "molecules.components.summaryPrice.total_msg"
                )}
              />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-6 col-md-3 mb-4">
                  <MoveBtn direction="back" title="Back" route="/orders" />
                </div>
                <MediaQuery query="(min-device-width: 481px)">
                  <div className="col-6" />
                </MediaQuery>
                <div className="col-6 col-md-3 mb-4">
                  <ActionBtn
                    action={() => this.props.showPDF(this.props.params.id)}
                    title="PDF"
                    icon="fa fa-file-pdf-o"
                    btnclassName="btn-danger"
                  />
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

OrderDetailContainer.propTypes = {
  orderData: PropTypes.shape({
    user: PropTypes.shape({
      personal: PropTypes.object,
      company: PropTypes.object
    })
  }),
  companyData: PropTypes.object
};

const mapStateToProps = ({ order, common, locale }) => ({
  translate: getTranslate(locale),
  orderData: getOrderDetail(order.detail),
  companyData: getCompanyDetail(common.user.company),
  currencySign: getCurrencySign(common.user.currency.sign),
  isLoading: order.orderLoading
});

const mapDispatchToProps = dispatch => ({
  showPDF: id => {
    dispatch(orderLoading(true));
    shop.getOrderPDF(id, urlPromise =>
      urlPromise.then(r => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.target = "_blank";
        a.href = r.url;
        a.download = id;
        a.click();
        dispatch(orderLoading(false));
        // window.open(r.url, '_blank')
      })
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(userIsAuthenticated(OrderDetailContainer));



// WEBPACK FOOTER //
// ./src/routes/OrderDetail/containers/OrderDetailContainer.js